import PROFILE from "./profile.en";
import ACCOUNT from "./account.en";

export default {
  ...PROFILE,
  ...ACCOUNT,
};
